export var menuItems={
  "data": [
    
    // {
    //   "path": "/",
    //   "title": "Dashboard",
    //   "icon": "stroke-board",
    //   "iconf":"fill-board",
    //   "icony":"fa fa-home",
    //   "type": "link",
    //   "active": false
    // },

    // {
    //   "path": "/users",
    //   "title": "Users",
    //   "icon": "stroke-board",
    //   "iconf":"fill-board",
    //   "icony":"icofont icofont-users",
    //   "type": "link",
    //   "active": false
    // },

    // {
    //   "path": "/campaigns",
    //   "title": "Campaigns",
    //   "icon": "stroke-board",
    //   "iconf":"fill-board",
    //   "icony":"fa fa-volume-down",
    //   "type": "link",
    //   "active": false
    // },

    // {
    //   "path": "/orders",
    //   "title": "Orders",
    //   "icon": "stroke-board",
    //   "iconf":"fill-board",
    //   "icony":"icon-write",
    //   "type": "link",
    //   "active": false
    // },

    // {
    //   "path": "/sliders",
    //   "title": "Sliders",
    //   "icon": "stroke-board",
    //   "iconf":"fill-board",
    //   "icony":"icon-layers-alt",
    //   "type": "link",
    //   "active": false
    // },

    // {
    //   "path": "/vendors",
    //   "title": "Vendors",
    //   "icon": "stroke-board",
    //   "iconf":"fill-board",
    //   "icony":"icofont icofont-users-alt-1",
    //   "type": "link",
    //   "active": false
    // },

    // {
    //   "title": "Reports",
    //   "icon": "stroke-knowledgebase",
    //   "iconf":"fill-knowledgebase",
    //   "icony":"icon-files",
    //   "type": "sub",
    //   "active": false,
    //   "children": [
    //     {
    //       "path": "/reports/user-report",
    //       "title": "User Report",
    //       "type": "link",
    //       "active":false
    //     },
    //     {
    //       "path": "/reports/order-report",
    //       "title": "Order Report",
    //       "type": "link",
    //       "active":false
    //     },
    //     {
    //       "path": "/reports/vendor-report",
    //       "title": "Vendor Report",
    //       "type": "link",
    //       "active":false
    //     },
        
    //   ]
    // },

    // {
    //   "title": "CMS",
    //   "icon": "stroke-knowledgebase",
    //   "iconf":"fill-knowledgebase",
    //   "icony":"icon-mobile",
    //   "type": "sub",
    //   "active": false,
    //   "children": [
    //     {
    //       "path": "/cms/aboutUs",
    //       "title": "About Us",
    //       "type": "link",
    //       "active":false
    //     },
    //     {
    //       "path": "/cms/help",
    //       "title": "Help Center",
    //       "type": "link",
    //       "active":false
    //     },
    //     {
    //       "path": "/cms/privacy",
    //       "title": "Privacy Policy",
    //       "type": "link",
    //       "active":false
    //     },
    //     {
    //       "path": "/cms/terms",
    //       "title": "Terms & Conditions",
    //       "type": "link",
    //       "active":false
    //     },
    //     {
    //       "path": "/cms/faq",
    //       "title": "FAQ",
    //       "type": "link",
    //       "active":false
    //     },
    //     {
    //       "path": "/cms/user_agreement",
    //       "title": "User Agreement",
    //       "type": "link",
    //       "active":false
    //     },
    //   ]
    // },

    // {
    //   "path": "/settings",
    //   "title": "Settings",
    //   "icon": "stroke-internationalization",
    //   "iconf":"fill-internationalization",
    //   "icony":"icon-settings",
    //   "type": "link",
    //   "active": false
    // },
    
  ]
}